import { render, staticRenderFns } from "./StockReductionNew_Total.vue?vue&type=template&id=e8b64d12&"
import script from "./StockReductionNew_Total.vue?vue&type=script&lang=js&"
export * from "./StockReductionNew_Total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports